import React from 'react';
import PropTypes from 'prop-types';

import TopBar from './Topbar';
import useStyles from './styles';

const GuestLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TopBar />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

GuestLayout.propTypes = {
  children: PropTypes.any
};

export default GuestLayout;
